export default __webpack_public_path__ + "static/media/set_logo.2b5583f6.svg";